// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3bBw9","colMaxWidth":"Table_colMaxWidth__23Dse"};